import React from "react";
import { Form, DatePicker } from 'antd';

const FormItem = Form.Item;

/**
 * A form that is used to search for a live schedule. It has two inputs, a dropdown to search for a schedule by date 
 and a date picker for the start date.
 */
class DetailedScheduleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 4 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 12 },
                sm: { span: 12 },
            },
        };

        return (

            <Form onSubmit={this.handleSubmit} {...formItemLayout}>
                <Form.Item label="Start Date" style = {{ marginTop: 20}}>
                    <DatePicker
                        onChange={this.props.handleStartDateChange}
                        value={this.props.detailedStartDate}
                        styles = {{
                            popup: {
                                root:{
                                    zIndex: 2000
                                }
                            }
                        }}
                    />
                </Form.Item>

                <Form.Item label="End Date">

                    <DatePicker
                        onChange={this.props.handleEndDateChange}
                        value={this.props.detailedEndDate}
                        styles = {{
                            popup: {
                                root:{
                                    zIndex: 2000
                                }
                            }
                        }}
                    />

                </Form.Item>
            </Form>
        );
    }
}

export default DetailedScheduleForm;

